<template>
  <a v-if="isOnUnlockPage" :href="registerUrl" @click.prevent="navigateToRegister">
    {{ label }}
  </a>
  <RouterLink v-else :to="routeDestination">{{ label }}</RouterLink>
</template>

<script setup>
import {getVideoAccessNow} from "@/composables/videoAccessNow";
import {computed} from "vue";
import {useRoute} from "vue-router";
import useUserSafe from "@/composables/useUserSafe";
import history from "@/assets/history.json";
import {getFullstackUrl} from "@/composables/useFullstackUrl";
import {getUrlWithAuth} from "@/composables/useUrlWithAuth";

const route = useRoute();
const {user} = useUserSafe();

const hasFullAccess = computed(() => {
  const videoAccess = getVideoAccessNow(user.value?.publicMetadata?.videoAccess);
  const year = Number(history.latestYear);
  return (
    (videoAccess.workshopVideosUntil || 0) >= year &&
    (videoAccess.masterclassVideosUntil || 0) >= year
  );
});

const isOnUnlockPage = computed(() => route.name === "Videos_Unlock");
const registerUrl = computed(() => `${getFullstackUrl()}/#register`);
const routeDestination = computed(() =>
  hasFullAccess.value ? {name: "Videos_Gallery"} : {name: "Videos_Unlock"}
);

const label = computed(() => {
  if (isOnUnlockPage.value) return "Register Now";
  return hasFullAccess.value ? "Video Library" : "Unlock All Videos";
});

function navigateToRegister() {
  window.location.href = getUrlWithAuth(registerUrl.value); // signed in there too
}
</script>

<style scoped>
a,
button {
  display: inline-flex;
  align-items: baseline;
  color: white;
  background-color: var(--brand-color);
  padding: 0.6rem 2.3rem;
  border: none;
  border-radius: 17px;
  cursor: pointer;
  white-space: nowrap;
  font-weight: bold;
  text-decoration: none;
}
a:hover,
button:hover {
  color: white;
  background-color: color-mix(in srgb, var(--brand-color), black 15%);
  text-decoration: none;
}
</style>
